const Logo = () => {
  return (
    <a href="/" className="flex items-center">
      <span className="text-2xl font-bold text-dark tracking-tight">LIDER</span>
    </a>
  );
};

export default Logo;